import React from 'react';
import {Row, Col} from 'antd';
import GroupCard from './GroupCard';

const StatusCards = ({loading, data}) => {
    return (
        <div>
            <Row style={{marginBottom: 10}} gutter={16}>
                <Col xs={24} xl={6}>
                    <GroupCard
                        title="Arızalı Araçlar"
                        count={data.red}
                        backgroundColor="red"
                        loading={loading}
                    />
                </Col>
                <Col xs={24} xl={6}>
                    <GroupCard
                        title="Uyarılı Araçlar"
                        count={data.orange}
                        backgroundColor="orange"
                        loading={loading}
                    />
                </Col>
                <Col xs={24} xl={6}>
                    <GroupCard
                        title="Hatasız Aktif Araçlar"
                        count={data.green}
                        backgroundColor="green"
                        loading={loading}
                    />
                </Col>
                <Col xs={24} xl={6}>
                    <GroupCard
                        title="Hatasız İnaktif Araçlar"
                        count={data.gray}
                        backgroundColor="gray"
                        loading={loading}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default StatusCards;
